import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import ReactSelect from 'react-select';

const propTypes = {
  classes: PropTypes.object.isRequired,
};

function ReactSelectWrapper({ classes, value, onChange, ...props }) {
  const [currentValues, setCurrentValues] = useState(value);
  useEffect(() => {
    setCurrentValues(value);
  }, [value]);

  const handleOnChange = selectedValues => {
    let selectedValue;
    let removedValue;
    if (Array.isArray(selectedValues)) {
      selectedValue = selectedValues?.find(sv => !currentValues?.some(cv => cv.value === sv.value));
      removedValue = currentValues?.find(sv => !selectedValues?.some(cv => cv.value === sv.value));
    } else {
      if (selectedValues) {
        selectedValue = selectedValues;
      } else {
        removedValue = currentValues[0];
      }
    }
    const event = {
      target: {
        value: selectedValue ? selectedValue.value : removedValue?.value,
      },
    };

    onChange(event);
  };

  return <ReactSelect className={classes.reactSelect} onChange={handleOnChange} value={value} {...props} />;
}

const styles = theme => ({
  reactSelect: {
    paddingTop: 8,
    paddingRight: 18,
    maxWidth: 400,
  },
});
ReactSelectWrapper.propTypes = propTypes;
export default withStyles(styles)(ReactSelectWrapper);
